module.exports = __webpack_public_path__ + "img/logo-icon-2.e5ccb95e.png";